import script from "./MemberJoinView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberJoinView.vue?vue&type=script&setup=true&lang=js"

import "./MemberJoinView.vue?vue&type=style&index=0&id=952d15aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-952d15aa"]])

export default __exports__